import { createFromIconfontCN } from '@ant-design/icons';

const hostname = window.__POWERED_BY_WUJIE__ ? window.__WUJIE_RAW_WINDOW__.location.hostname : window.location.hostname;
const port = window.__POWERED_BY_WUJIE__ ? window.__WUJIE_RAW_WINDOW__.location.port : window.location.port;

/** 字体图标 */
const FromIconFont = createFromIconfontCN({
  scriptUrl: `//${hostname}${port ? ':' + port : ''}/data/iconFont.js`,
});

export default FromIconFont;
